'use client';

import Header from '@/components/common/Header';
import HomeInteractive from './components/HomeInteractive';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HomeInteractive />
      </main>
    </>
  );
}